const MarketingHubIcon = ({ active = false }) => {
  const notActive = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke="#757575" strokeWidth="1.5" />
      <path
        d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"
        stroke="#757575"
        strokeWidth="1.5"
      />
      <path d="M2 12h20" stroke="#757575" strokeWidth="1.5" />
    </svg>
  );

  const isActive = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" fill="#3C3C3C" />
      <path
        d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"
        stroke="white"
        strokeWidth="1.5"
      />
      <path d="M2 12h20" stroke="white" strokeWidth="1.5" />
    </svg>
  );

  return active ? isActive : notActive;
};

export default MarketingHubIcon;
